import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";
import { Navigate } from "@tanstack/react-router";
import { useState } from "react";

import { UsernameDialog } from "../components/UsernameDialog.js";
import { useShopper } from "../lib/shopper.js";
import { useTenant } from "../lib/tenant.js";
import {
  useForgeBuilderContent,
  useForgeBuilderHeading,
  useUsernameGate,
} from "../templates/pages/forge/useForgeBuilderContent.js";
import { storefrontTemplateOf } from "../templates/registry.js";

/**
 * POST /v1/forge/boxes: the builder, for a signed-in shopper with a username. Signed out, it
 * sends the shopper to sign in; without a username, it asks for one first.
 */
export function ForgeCreatePage() {
  const { user, authPending } = useShopper();
  const { config } = useTenant();
  const [usernameOpen, setUsernameOpen] = useState(false);
  const notice = useUsernameGate({ open: usernameOpen, onOpenChange: setUsernameOpen });
  const heading = useForgeBuilderHeading("create", false);

  if (!authPending && !user) return <Navigate to="/login" replace />;
  if (notice) {
    return (
      <>
        <PageTemplateView
          template={storefrontTemplateOf(config).forgeBuilder}
          content={{ heading, notice }}
        />
        {usernameOpen && (
          <UsernameDialog open={usernameOpen} onOpenChange={setUsernameOpen} username={null} />
        )}
      </>
    );
  }
  return <ForgeBuilder />;
}

function ForgeBuilder() {
  const { config } = useTenant();
  const { content, usernameDialog } = useForgeBuilderContent();
  return (
    <>
      <PageTemplateView template={storefrontTemplateOf(config).forgeBuilder} content={content} />
      {usernameDialog.open && <UsernameDialog {...usernameDialog} username={null} />}
    </>
  );
}
